import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "./api";

const get = (url) => async () => (await api.get(url)).data;

export const useSessions = () => useQuery({ queryKey: ["sessions"], queryFn: get("/sessions") });
export const useFlips = () => useQuery({ queryKey: ["flips"], queryFn: get("/flips") });
export const useCards = () => useQuery({ queryKey: ["cards"], queryFn: get("/cards") });
export const usePrefs = () => useQuery({ queryKey: ["prefs"], queryFn: get("/prefs"), staleTime: 60000 });

function useMut(fn, keys) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: fn,
    onSuccess: () => keys.forEach((k) => qc.invalidateQueries({ queryKey: [k] })),
  });
}

export const useCreateSession = () => useMut(async (b) => (await api.post("/sessions", b)).data, ["sessions"]);
export const useUpdateSession = () =>
  useMut(async ({ id, patch }) => (await api.patch(`/sessions/${id}`, patch)).data, ["sessions"]);
export const useDeleteSession = () => useMut(async (id) => (await api.delete(`/sessions/${id}`)).data, ["sessions", "flips"]);

export const useSaveFlip = () => useMut(async (b) => (await api.post("/flips", b)).data, ["flips"]);
export const useToggleFlipDone = () =>
  useMut(async ({ entryId, index }) => (await api.post(`/flips/${entryId}/toggle/${index}`)).data, ["flips"]);
export const useDeleteFlip = () => useMut(async (id) => (await api.delete(`/flips/${id}`)).data, ["flips"]);

export const useToggleCard = () => useMut(async (b) => (await api.post("/cards/toggle", b)).data, ["cards"]);
export const useDeleteCard = () => useMut(async (id) => (await api.delete(`/cards/${id}`)).data, ["cards"]);

export function useSavePrefs() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (patch) => (await api.put("/prefs", patch)).data,
    onMutate: (patch) => qc.setQueryData(["prefs"], (old) => ({ ...(old || {}), ...patch })),
    onSuccess: (data) => qc.setQueryData(["prefs"], data),
  });
}

export async function aiPost(path, body, field) {
  try {
    const { data } = await api.post(`/ai/${path}`, body);
    return data[field] ?? (field === "schemas" ? [] : "");
  } catch {
    return field === "schemas" ? [] : "";
  }
}
